import { z } from 'zod';
import { phoneNumberValidation, stringConstraints } from './common';

export const yourDetailsSchema = z.object({
  firstName: stringConstraints('Please enter your first name'),
  lastName: stringConstraints('Please enter your last name'),
  email: z.string().email('Please enter your email address'),
  phoneNumber: phoneNumberValidation(
    'Please enter your phone number',
    'Enter a valid phone number',
  ),
});
